/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	ProfessorProposalReportDTO,
	ProfessorProposalReportDTOFromJSON,
	ProfessorProposalReportDTOFromJSONTyped,
	ProfessorProposalReportDTOToJSON,
} from "./ProfessorProposalReportDTO";

/**
 *
 * @export
 * @interface ProfessorProposalReportDTOPagedResponse
 */
export interface ProfessorProposalReportDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof ProfessorProposalReportDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof ProfessorProposalReportDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof ProfessorProposalReportDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<ProfessorProposalReportDTO>}
	 * @memberof ProfessorProposalReportDTOPagedResponse
	 */
	data?: Array<ProfessorProposalReportDTO> | null;
}

export function ProfessorProposalReportDTOPagedResponseFromJSON(
	json: any
): ProfessorProposalReportDTOPagedResponse {
	return ProfessorProposalReportDTOPagedResponseFromJSONTyped(json, false);
}

export function ProfessorProposalReportDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ProfessorProposalReportDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(ProfessorProposalReportDTOFromJSON),
	};
}

export function ProfessorProposalReportDTOPagedResponseToJSON(
	value?: ProfessorProposalReportDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(ProfessorProposalReportDTOToJSON),
	};
}
